/**
 * Labstep
 *
 * @module components/ExperimentWorkflow/Action/Delete
 * @desc Action to delete experiment workflow
 */

import { EntityActionDelete as DeleteAction } from 'labstep-web/components/Entity/Action/Delete';
import type React from 'react';
import type { ExperimentWorkflowActionDeleteProps } from './types';

export const ExperimentWorkflowActionDelete: React.FC<
  ExperimentWorkflowActionDeleteProps
> = ({ experimentWorkflow }) => (
  <DeleteAction
    dataCy="components/ExperimentWorkflow/Action/Delete"
    entity={experimentWorkflow}
  />
);
